import type * as T from './src/evans/pairs';
import EvansClient from './src/evans/EvansClient';
export type { T };
export default EvansClient;
